module.exports = "<fuse-navigation layout=\"horizontal\"></fuse-navigation>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/navbar/horizontal/navbar-horizontal.component.html
// module id = ./src/app/main/navbar/horizontal/navbar-horizontal.component.html
// module chunks = main